import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  IconButton,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconClose } from 'assets/icons';
import { ControllableModal } from 'components/Modal';

interface IDeleteUserModal {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body?: React.ReactNode;
  confirmButtonLabel: string;
  confirmButtonProps?: any;
  hideCloseButton?: boolean;
}

const DeleteUserModal: React.FC<IDeleteUserModal> = ({
  isOpen,
  onClose,
  title,
  body,
  confirmButtonLabel,
  confirmButtonProps,
  hideCloseButton = false,
}) => {
  const { t } = useTranslation(['common', 'employees']);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  return (
    <ControllableModal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalContent pt={2}>
        <ModalHeader>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading as="h6" size="md" mb="2" data-testid="modal-title">
              {title}
            </Heading>
            {!hideCloseButton && (
              <IconButton
                as={IconClose}
                p={2.5}
                aria-label="Close"
                variant="ghost"
                cursor="pointer"
                size="sm"
                onClick={() => {
                  setIsChecked(false);
                  onClose();
                }}
              />
            )}
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Box letterSpacing={-0.3} fontWeight={600}>
            {body && body}
            <Checkbox
              isChecked={isChecked}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIsChecked(e.target.checked)}
              mt={3}
              data-testid="modal-checkbox"
              colorScheme="primary"
            >
              <Text fontSize="sm" fontWeight={700}>
                {t('employees:deleteUserModal.checkboxLabel')}
              </Text>
            </Checkbox>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" justifyContent="center">
            <Button
              variant="ghost"
              width="150px"
              data-testid="button-cancel"
              onClick={() => {
                setIsChecked(false);
                onClose();
              }}
            >
              {t('common:cancel')}
            </Button>
            <Button
              minWidth="170px"
              fontWeight="semibold"
              {...confirmButtonProps}
              onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                if (confirmButtonProps?.onClick) confirmButtonProps?.onClick(e, setIsChecked);
              }}
              data-testid="button-submit"
              isDisabled={!isChecked}
            >
              {confirmButtonLabel}
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </ControllableModal>
  );
};

export default DeleteUserModal;
